import { AsyncPipe } from '@angular/common';
import {
  Component,
  inject,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

import {
  SettingsResponse,
} from '#interfaces/http-response/responses/http-responses';
import {
  SettingsService,
} from '#services/settings/settings.service';
import { AlertService } from '#utils/alert-service/alert-service.service';
import { LocalStorageService } from '#utils/local-storage/local-storage.service';
import { MatIconModule } from '@angular/material/icon';
import {
  first,
  Observable,
} from 'rxjs';

@Component({
    selector: 'app-settings-user',
    templateUrl: './settings-user.component.html',
    styles: [],
    imports: [AsyncPipe, MatIconModule, ReactiveFormsModule]
})
export class SettingsUserComponent implements OnInit {
  private _storage = inject(LocalStorageService);
  public settingsForm;

  public $settings: Observable<SettingsResponse>;

  constructor(private fbuilder: FormBuilder, private _settingsService: SettingsService, public matDialog: MatDialog, private _alertService: AlertService) {
    this.settingsForm = this.fbuilder.group({
      longOpportunityMonths: [1, [Validators.required, Validators.min(1), Validators.max(6)]]
    });
  }

  ngOnInit(): void {
    this.$settings = this._settingsService.settings$
    this._settingsService.Get().pipe(first()).subscribe(({ data }) => {
      this.settingsForm.controls.longOpportunityMonths.setValue(data.schedule ?? 0)
    });
  }

  public saveChanges() {
    const { longOpportunityMonths } = this.settingsForm.controls;
    const currentUserId = this._storage.getUserId();
    return this._settingsService.UpdateSchedules(currentUserId, longOpportunityMonths.value).subscribe({
        next: ({ message }) => {
            this._alertService.saveAlert(message);
            this.matDialog.closeAll();
        },
        error: () => {
            this._alertService.errorAlert([], 'Se ha producido un error al guardar los cambios, revisa que hayas puesto las opciones correctamente.');
        }
    });
}
}
